export default "__VITE_ASSET__1b97f819__"